// hooks/useNotifications.js
import { useContext } from 'react';
import NotificationContext from '../contexts/NotificationContext';

/**
 * 通知系統的自定義 Hook
 * 提供顯示、隱藏和管理通知的功能
 */
export const useNotifications = () => {
    const context = useContext(NotificationContext);

    if (!context) {
        throw new Error('useNotifications 必須在 NotificationProvider 內部使用');
    }

    return context;
};

export default useNotifications;